export const lang = {
    header:{
        home:'首页',
        aboutUs:'关于我们',
        service:'产品和服务',
        concatUs:'联系我们',
    },
    homePage:{
        senseOfWorth:'核心价值观',
        corporateMission:'公司使命',
        strategic:'战略目标',
        detail1:'创新、能力、合作、竞争',
        detail2:'用更好的游戏连接阿拉伯',
        detail3:'影响每一个阿拉伯用户，让生活更美好',
        teamAtrength1:'环阿网络科技有限公司由来自阿拉伯地区的资深游戏人创立，由一批游戏行业经验丰富的专业人士构成，团队成员分别来自iGG、网龙、龙腾简合、字节跳动等知名游戏公司及互联网企业。',
        teamAtrength2:'团队成员拥有多款中东端游、页游及手游的发行经验及本地化经验，与中东当地资深的游戏配音工作室、KOL团队及中东最大的广播电视集团MBC保持紧密合作，拥有一线新媒体营销资源。',
        teamAtrength3:'Arab Online团队凝聚力强，热爱游戏行业，始终保持追求卓越和向上的自我驱动力共同为玩家提供最优质的游戏体验，为本地化客户及开发商提供最专业的服务体验。',
        faxingyw:'游戏发行业务',
        bendihYw:'本地化业务',
        cpyr:'产品引入',
        swpphz:'商务/品牌合作',
        qdhz:'渠道合作',
        jrqm:'加入我们',
        m2016: '公司成立，同年11月首款联合发行产品INVASION上线',
        m2017: '联合发行产品WARFARE STRIKE上线',
        m2018: 'INVASION流水达到峰值，长期稳定中东区域畅销总榜前三，游戏榜第二',
        m2019: '联合发行魔幻风格SLG产品VAMPIRE EMPIRE上线',
        m2020: '多款游戏产品本地化包装',
        readMore: '阅读更多',
        rmal: '热门案例',
        gs: '公司',
        fl: '法律',
        gsfzlc: '公司发展历程',
        tdsl: '团队实力',
        gsyj: '公司愿景',
        zpzs: '作品展示',
        publishProject: '联合发行项目',
        AboutUs: '公司介绍',
        cookie: 'COOKIE政策',
        sytk: '使用条款'
    },
    business:{
        invasion:{
            a1:'产品名',
            a2:'开发者',
            a3:'产品简介：',
            a4:'Invasion是成都Tap4Fun推出的战争策略手游，荣获App Store官方推荐！游戏主旨围绕着打造最强基地-战胜敌人而展开，玩家在游戏中需要培养自己的基地建筑、同时最大化资源优势、生产足够多的武装力量，从而使自己的基地成为最强的军事堡垒。',
            a5:'合作方式：',
            a6:'本地化包装 + 联合发行运营',
            a7:'合作亮点：',
            a8:'邀请”中东麦当娜“Haifa Wahbe倾情代言，成为中东历史上首款明星合作代言手游',
            a9:'2016年-2020年间多次荣获AppStore及Google Play首页大屏推荐',
            a10:'双端月流水最高超200万美金，长达1年多持续占据海湾六国游戏畅销榜TOP2',
        },
        warfare:{
            a4:'《Warfare Strike》是一款为阿语玩家定制、全新多人slg战争游戏，可以和朋友们一同竞技，感受战争乐趣。合理地利用天时地利人和，管理城市资源，运筹帷幄，成为这个乱世中真正的霸主。',
            a5:'本地化包装+联合发行运营',
            a6:'高ARPPU是该游戏最突出的特点',
            a7:'曾进入沙特阿拉伯地区游戏畅销榜TOP20',
            a8:'',
            // a5:'',
            // a5:'',
        },
        clashForDawn:{
            a4:'《Clash for Dawn》游戏讲述了米德加尔特大陆面临无尽军团、巨龙等邪恶势力的入侵，玩家可扮演战士、法师、弓箭手、牧师等类型的职业，与人类一起化解这场浩劫。',
            a5:'本地化包装+联合发行运营',
            a6:'第一款完成本地化并首次在中东发行运营的ARPG',
            a7:'探索了阿拉伯地区玩家对魔幻风格MMO游戏的接受度'
        },
        totalDestruction:{
            a4:'《战火奇兵》是一款多人在线的策略游戏，游戏背景为列强纷争的时代，一场大战打破了两大帝国制衡的局面，帝国的附属国纷纷自立为王，为争夺大陆之王大兴军事；玩家在游戏中扮演一个国家的君王，兴建城邦，招兵买马，建立属于自己的史诗级国度。',
            a5:'本地化包装+发行运营',
            a6:'将中文版《战火奇兵》结合中东战争历史文化，重构背景故事和世界观，获得中东地区玩家高度的共鸣和正向反馈',
            a7:'由中东本地知名音乐制作团队操手设计游戏BGM，得到CP和阿拉伯玩家的一致好评',
            a8:'广告素材从地理环境、建筑特色、民俗风情与文字都精细化包装，从本地出发，落向阿拉伯玩家',
            a9:'多元化的广告创意结合设计团队的专业能力，表现最优素材CTR达4%以上，整体平均CTR保持2%以上, CVR20.47%'
        },
        vampireEmpire:{
            a4:'《嗜血王朝》是一款基于中世纪背景的策略类手游，讲述的是吸血鬼与人类为争夺生存统治权对抗了数百年的故事。',
            a5:'本地化包装+联合发行运营',
            a6:'迪士尼电影《狮子王》中东版本配音的首席声优加盟，倾情演绎吸血鬼德库拉',
            a7:'完整的广告计划，密集记录、监控和优化广告，提升表现数据',
            a8:'优秀的广告创意，诞生了多款吸量的图片及视频，Android广告整体平均CTR 1.48%，CVR 20.62%',
            kaifashang:'Gekko Game',
            name:'Vampire Empire'
        },

        powerAndHonor:{
            a4:'《权利和荣耀》是一款祖龙游戏出品，以中世纪西方魔幻为题材，描述了六个不同国家之间王权争夺的MMORPG。',
            a5:'本地化包装',
            a6:'英雄的本地化，使其更符合中东玩家审美',
            a7:'文字、游戏菜单调整，适应阿拉伯语玩家阅读的方式',
            kaifashang:'Archosaur Game'
        },
        brutalAge:{
            a4:'《野蛮时代》是一款原始题材的大型多人MMO策略游戏。玩家将化身原始人，体验最原始、最有趣的狩猎与激斗，和部落联盟的盟友一起，享受一场史前捕猎盛宴。',
            a5:'本地化包装',
            a6:'聘请当地知名翻译专家加入，确保地道、高品质的翻译效果',
            a7:'阿拉伯当地专业配音团队，将原始人音色及表达特点处理得栩栩如生，玩家仿佛就置身部落乐在其中',
            a8:'专业的美术团队，融合了原始人的面部和行为风格并结合阿拉伯人形态特征共同设计',
            a9:'阿拉伯地区游戏类KOL助阵，高度曝光游戏',
            kaifashang:'Tap4Fun',
            name:'Brutal Age'
        },
        thisNew:{
            a4:'《This New》是一款针对中东用户的DIY电商产品，致力于帮助消费者根据自己的喜好，选择心仪的产品进行DIY。独家定制，个性无限。',
            a5:'本地化包装',
            a6:'是第一款合作的电商工具产品',
            a7:'产品主视觉配色、UI及文字本地化翻译，更贴近阿拉伯地区电商行业的喜好',
            kaifashang:'ZiXun',
            name:'This New'
        },
        gameOfKings:{
            a4:'王的游戏：血色王座”是一款关于中世纪战争完全免费的即时策略手游。在这里，与敌军、巨龙和怪物浴血奋战，成为荣耀之王。',
            a5:'本地化包装',
            a6:'与开发商在本地化的理念上一拍即合，整体的工作沟通非常流畅和高',
            kaifashang:'Koofei',
            name:'Game of Kings'
        },
        warOfSteel:{
            a4:'《全线警戒》是一款现代战争策略手游，是一款模拟城市在混乱之地中与其他城市间的发展、合作和冲突的多人战争经营策略类游戏。',
            a5:'本地化包装',
            a6:'重构游戏背景和世界观',
            a7:'游戏英雄全面本地化',
            kaifashang:'iLead',
            name:'War of Steel'
        },
    },
    login: '登录',
    register: '注册',
    welcome: '欢迎',
    logout: '退出'
}


// WEBPACK FOOTER //
// ./src/components/lang/zh.js